<template>
	<div>
		<!-- Detail -->
    <transition name="fade">
      <div class="position-relative z-index-1045">
        <div class="row no-gutters justify-content-center">
          <div class="position-fixed w-100 d-block nav-bottom" style="bottom:0;top: 0">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="bg-white">
                    <div class="w-100 popup-full">
                      <div class="container p-4">
                        <div v-if="is_load" class="w-100 text-center my-5">
                          <loader></loader>
                        </div>
                        <template v-else>
                          <div class="my-4" v-if="error != ''">
                            <ErrorMessage :message="error" />
                          </div>
                          <template v-else>
                            <div>
                              <div class="position-relative" style="top: -7px">
                                <img src="../../../../assets/img/icon/close.png" width="16" class="cursor-pointer d-inline-block" @click="close">
                              </div>  
                              <div class="row slim-grid-row mb-2">
                                <div class="col-12">
                                  <p class="mb-0 body-2-2 font-bold text-18 w-100 d-inline-block mt-3 text-center" @click="test">{{detail_data.name}}</p>
                                  <!-- <p class="mb-0 body-2-2 text-14 font-regular">{{detail_data.description}}</p> -->
                                </div>
                              </div>
                              <div v-if="data.length > 1" class="container px-4 pt-2 sticky bg-white">
                                <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: 0" @click="xScroll('left', 'room')">
                                  <div class="next-button p-1px">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path class="fill-primary" d="M16.2541 4.24106C16.5522 4.53326 16.5793 4.99051 16.3354 5.31272L16.2541 5.40503L9.52658 12L16.2541 18.595C16.5522 18.8872 16.5793 19.3444 16.3354 19.6666L16.2541 19.7589C15.956 20.0511 15.4896 20.0777 15.161 19.8386L15.0668 19.7589L7.7459 12.582C7.44784 12.2898 7.42074 11.8325 7.66461 11.5103L7.7459 11.418L15.0668 4.24106C15.3947 3.91965 15.9262 3.91965 16.2541 4.24106Z" fill="#130F26"/>
                                    </svg>
                                  </div>
                                  <!-- <img src="../../../../assets/img/icon/orange-arrow-left.png" width="18" class="next-button position-relative" style="left: 0;z-index: 9"> -->
                                </div>
                                <div class="div-wrapper mx-auto d-inline-block m-width-100 position-relative left-0-d pb-1" id="room" style="width: 97%;">
                                  <div class="text-center mx-auto" style="width: max-content">
                                    <div class="text-center d-inline-block cursor-pointer" v-for="(category, index) in data" @click="category_selected = category">
                                      <p class="body-2 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer text-12 bg-light-page mr-2 rounded-3" :class="{'font-bold delay bg-orange text-white border-orange':category_selected.id == category.id}">{{category.name}}</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: 0;" @click="xScroll('right', 'room')">
                                  <div class="next-button p-1px">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path class="fill-primary" d="M7.7459 19.7589C7.44784 19.4667 7.42074 19.0095 7.66461 18.6873L7.7459 18.595L14.4734 12L7.7459 5.40503C7.44784 5.11283 7.42074 4.65558 7.66461 4.33338L7.7459 4.24106C8.04396 3.94887 8.51037 3.9223 8.83904 4.16137L8.93321 4.24106L16.2541 11.418C16.5522 11.7102 16.5793 12.1675 16.3354 12.4897L16.2541 12.582L8.93321 19.7589C8.60534 20.0804 8.07376 20.0804 7.7459 19.7589Z" fill="#130F26"/>
                                    </svg>
                                  </div>
                                  <!-- <img src="../../../../assets/img/icon/orange-arrow-right.png" width="18" class="next-button position-relative" style="right: 11px;z-index: 9"> -->
                                </div>
                              </div>
                            </div>
                            <div class="pb-2 pt-3 mt-3 border-top border-bottom">
                              <div class="">
                                <p class="mb-3 body-1-1 font-bold text-16 text-center pb-2">{{$t("hotel.concierge.fitur.laundry.price-list")}}</p>
                                <div class="w-100" :style="price_list_style">
                                  <div class="w-100" v-for="(product_detail,index) in category_selected.product_list" :key="index">
                                    <menuProductLaundry :data="product_detail" :service="detail_data"></menuProductLaundry>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="">
                              <div style="height: 75px;"></div>
                              <div class="row no-gutters justify-content-center">
                                <div class="position-fixed w-100 d-block nav-bottom" style="bottom:0;">
                                  <div class="custom-container-fluid px-0">
                                    <div class="row justify-content-center no-gutters">
                                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                        <div class="bg-white container px-4 w-100 py-1">
                                          <button type="button" class="button-secondary border-black bg-white text-dark w-100" v-if="is_cart" @click="addToCart(detail_data)">{{$t('hotel.action.cancel-service')}}</button>
                                          <button type="button" class="button-secondary w-100" v-else @click="addToCart(detail_data)">{{$t('hotel.action.select-service')}}</button>
                                          <p class="mb-0 mt-1 text-center text-10 body-2 font-regular">{{$t('hotel.concierge.laundry-staff-will-calculate')}}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="position-relative z-index-1038">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-12 position-relative">
                  <div class="">
                    <div class="w-100 py-2 px-2" 
                    @click="close"
                      style="height: 100vh;background-color: #00000099">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
    <!-- Pop Up Cart -->
    <template v-if="getConciergeOrder.custom.length > 0">
      <div style="height: 60px;"></div>
      <div class="position-relative" style="z-index: 1050">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="bottom:0">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="container px-4 bg-white height-75px">
                    <div class="row justify-content-center slim-grid-row">
                      <div class="col-12">
                        <router-link :to="'/'+getMerchant.code+'/concierge/laundry/cart'">
                          <div class="rounded-4 bg-orange w-100 px-3 py-3">
                            <div class="row no-gutters">
                              <div class="col-4 align-self-center">
                                <img src="../../../../assets/img/icon/cart.png" width="20" style="vertical-align: -webkit-baseline-middle">
                              </div>
                              <div class="col-8 text-right align-self-center">
                                <p class="text-white text-right mb-0 body-2-4 text-16 text-truncate">{{getConciergeOrder.custom.length}} {{$t('hotel.concierge.service-selected')}}</p>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import {formatCurrency} from '@/utils/index.js'
  import {get} from '@/services/index.js';
  import menuProductLaundry from '@/components/hotel/concierge/general/menuProductLaundry'

	export default{
		props: ['detail_data'],
    components:{
      menuProductLaundry
    },
    data(){
      return{
        data: {},
        is_load: true,
        error: '',
        category_selected: {},
        show_popup: false
      }
    },
		computed:{
      ...mapGetters([
        'getMerchant',
        'getConciergeOrder',
        'getMembershipRewardApplied',
        'isMembershipRewardApplied']),
			is_cart(){
				let serv_record = this.getConciergeOrder.custom.findIndex(x=>x.product.id == this.detail_data.id)
        if(serv_record == -1){
          return false
        }else{
          return true
        }
			},
      price_list_style(){
        let height = this.data.length > 1 ? '300' : '350'
        return 'max-height:'+height+'px;'+'overflow: hidden auto;'
      }
		},
    mounted(){
      this.loadDetailData()
    },
		methods:{
      ...mapMutations(['setConciergeOrderCustom','removeConciergeOrderCustom','resetConciergeOrder','setConciergeOrderCustomModule']),
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
        console.log(content.scrollLeft)
      },
      test(){
        this.resetConciergeOrder()
      },
      addToCart(service){
        let params = {
          product: service,
          type: 'pcs'
        }
        if(!this.is_cart){
          this.setConciergeOrderCustom(params)
          this.setConciergeOrderCustomModule("laundry")
        }else{
          this.removeConciergeOrderCustom(service.id)
        }
        this.close()
        // if(this.getConciergeReservation().status == 'CHECKIN'){
        // }else{
        //   this.show_popup = true
        // }
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      close(){
      	this.$emit('close')  
  		},
      loadDetailData(){
        this.is_load = true
        this.error = ''
        this.data = {}

        get("CONCIERGE","laundry/variant/pcs/"+this.detail_data.code,{
          merchant_id: this.getMerchant.id,
          membership_reward_id: this.isMembershipRewardApplied ? this.getMembershipRewardApplied.id : ''
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.category_selected = res.data[0]
            this.data = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/detailLaundryService.vue